import React, { useState } from 'react'

export function useInstallPrompt() {
    const [eventState, setEventState] = useState(undefined)

    const TRIGGER = "eventChanged"

    function  checkInstalledApps() {
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault()
        // Stash the event so it can be triggered later.
        setEventState(e)
        // Dispatch the event
        document.dispatchEvent(new CustomEvent(TRIGGER, {detail: e}))
      })
    }

    function onDeferredPromptChanged(callback) {
      document.addEventListener(TRIGGER, (e) => callback(e.detail));
    }

    function updateEventState(e) {
      setEventState(e)
      document.dispatchEvent(new CustomEvent(TRIGGER, {detail: e}))
    }

    const getEventState = () => {
      return eventState
    }

    checkInstalledApps()

    return [getEventState, onDeferredPromptChanged]
}